import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holiday-bonus-card',
  templateUrl: './holiday-bonus-card.component.html',
  styleUrls: ['./holiday-bonus-card.component.scss']
})
export class HolidayBonusCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/holiday-bonus-card/holiday-bonus-card.component.ts